import React from "react"
import {
  Button,
  CircularProgress,
  Theme,
  Tooltip,
  ButtonProps,
  makeStyles,
  createStyles
} from "@material-ui/core"

const useStyles = makeStyles(({spacing}: Theme) =>
  createStyles({
    wrapper: {
      position: "relative"
    },
    buttonProgress: {
      color: "white",
      position: "absolute",
      top: "20%",
      right: "5%"
    },
    sizeLarge: {
      height: spacing(5)
    }
  })
)
interface IMainButtonProps extends ButtonProps {
  readonly text: string
  readonly className?: string
  readonly onClick?: () => void
  readonly disabled?: boolean
  readonly secondary?: boolean
  readonly showLoading?: boolean
  readonly tooltipMessage?: string
}
const MainButton: React.FunctionComponent<IMainButtonProps> = ({
  text,
  className,
  onClick,
  disabled,
  secondary,
  showLoading,
  tooltipMessage,
  ...buttonProps
}) => {
  const classes = useStyles()
  return (
    <div className={classes.wrapper}>
      <Tooltip title={tooltipMessage || ""}>
        <Button
          variant={secondary ? "outlined" : "contained"}
          style={{
            textTransform: "none",
            width: "100%"
          }}
          color={secondary ? "default" : "primary"}
          className={className}
          size="large"
          onClick={onClick}
          disabled={disabled}
          disableElevation
          classes={{sizeLarge: classes.sizeLarge}}
          {...buttonProps}
        >
          {text}
        </Button>
      </Tooltip>
      {disabled && showLoading && (
        <CircularProgress className={classes.buttonProgress} size={20} />
      )}
    </div>
  )
}
export default MainButton
